/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type ListingDetailOutdoorSpaceResponseDtoKind = typeof ListingDetailOutdoorSpaceResponseDtoKind[keyof typeof ListingDetailOutdoorSpaceResponseDtoKind];


export const ListingDetailOutdoorSpaceResponseDtoKind = {
  BALCONY: 'BALCONY',
  LOGGIA: 'LOGGIA',
  TERRACE: 'TERRACE',
  CELLAR: 'CELLAR',
} as const;
